module.exports = __webpack_public_path__ + "assets/img/The-Onset-Website-w540.14d940ab.jpg";